module.exports = __webpack_public_path__ + "static/media/chassis_parts_052123.b6704797.png";